export default "__VITE_ASSET__D9qds0EM__"